angular.module('bb.listing_search').config(ListingSearchRoutes);

ListingSearchRoutes.$inject = ['$routeProvider'];
function ListingSearchRoutes($routeProvider) {
  $routeProvider
    .when('/listing/list/brokerage/:pageNumber', {
      template: '',
    })
    .when('/listing/list/:type/:pageNumber', {
      template: '<listing-search />',
    })
    .when('/appointment/list/:type', {
      template: '<bb-appointment-search />',
    });
}

export {};
